import { Button } from 'react-bootstrap/lib';
import React, { useState } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import './CDKSaveDealChallengeModal.scss';
import CloseIcon from '../../../../components/Icons/Close';

const MODAL_STYLE = {
  content: {
    margin: '10% auto',
    maxWidth: '60%',
    minHeight: '30%',
    maxHeight: '60%',
    position: 'relative',
    padding: 0,
  },
};

const MODAL_HEADER = 'Please Save Deal in DMS';
const MODAL_TEXT =
  'Deal needs to be saved in the DMS in order to pull accurate pricing information. Please open this deal in the DMS and save it before pulling the numbers.';
const CHALLENGE_TEXT =
  'Do you want to proceed even though this deal has not been updated from the DMS?';

const CANCEL_BUTTON_TEXT = 'Cancel';
const YES_PROCEED_BUTTON_TEXT = 'Yes, Proceed Anyway';

function CDKSaveDealChallengeModal(props) {
  // determines if modal is open or not
  const { submitFn, setShowSaveDealInCDKChallenge } = props;
  const [isOpen, setIsOpen] = useState(props);

  const closeModal = () => {
    setIsOpen(false);
    setShowSaveDealInCDKChallenge(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={MODAL_STYLE}
      ariaHideApp={false}
    >
      <div className="cdk-save-deal-challenge-modal-header">
        <div>{MODAL_HEADER}</div>
        <CloseIcon onClick={closeModal} />
      </div>
      <div className="cdk-save-deal-challenge-modal-body">
        <div>{MODAL_TEXT}</div>
        <div className="cdk-save-deal-challenge-text">{CHALLENGE_TEXT}</div>
      </div>
      <div className="cdk-save-deal-challenge-button-container">
        <Button
          className="cdk-save-deal-challenge-cancel-button cdk-save-deal-challenge-button btn btn-default"
          onClick={closeModal}
        >
          {CANCEL_BUTTON_TEXT}
        </Button>
        <Button
          className="cdk-save-deal-challenge-yes-button cdk-save-deal-challenge-button btn-primary"
          onClick={() => {
            closeModal();
            submitFn();
          }}
        >
          {YES_PROCEED_BUTTON_TEXT}
        </Button>
      </div>
    </Modal>
  );
}

CDKSaveDealChallengeModal.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  isOpen: PropTypes.bool,
  submitFn: PropTypes.func,
  setShowSaveDealInCDKChallenge: PropTypes.func,
};

export default CDKSaveDealChallengeModal;
